// Arkadaşlar + oyun daveti paneli ve gelen davet diyaloğu (Katıl/Reddet).
// React'ten bağımsız, body'ye eklenen DOM overlay'leri — UMO'daki friends.js ile
// aynı davranış: GET /v1/friends + GET/POST /v1/game-invitations (nativeBridge
// üzerinden, gameType 'batak'). Oturan oyuncu kendi masasına davet eder; oturmuyorsa
// backend yeni özel masa üretir. Masa seçici yok.
import {
    fetchFriendsList,
    fetchGameInvitations,
    sendGameInvite,
} from './nativeBridge';

const ERROR_TR = {
    NOT_FRIENDS: 'Vous n’êtes pas amis',
    INVITEE_UNAVAILABLE: 'Cet utilisateur ne peut pas être invité pour le moment',
    INVITE_RATE_LIMITED: 'Tu envoies trop d’invitations, attends un peu',
    INVITE_LIMIT_REACHED: 'Tu as atteint la limite d’invitations en attente',
    INVITES_DISABLED: 'Les invitations sont désactivées pour le moment',
    SELF_INVITE: 'Tu ne peux pas t’inviter toi-même',
    INVALID_GAME_TYPE: 'Jeu invalide',
    INVALID_CALLER_ID: 'Utilisateur invalide',
    UNAUTHORIZED: 'Session non vérifiée',
};

const STYLE_ID = 'batak-invite-styles';
const CSS = `
#batak-friends-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.45); z-index: 9980; display: none; }
#batak-friends-overlay.visible { display: block; }
#batak-friends {
  position: fixed; top: 0; right: 0; width: min(78vw, 380px); height: 100vh;
  background: rgba(14,24,44,0.97); backdrop-filter: blur(6px); -webkit-backdrop-filter: blur(6px);
  border-radius: 16px 0 0 16px; box-shadow: -6px 0 24px rgba(0,0,0,0.5); z-index: 9981;
  display: none; flex-direction: column; color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  padding: calc(env(safe-area-inset-top, 0px) + 12px) 14px calc(env(safe-area-inset-bottom, 0px) + 10px) 14px;
}
#batak-friends.visible { display: flex; }
#batak-friends-header { display: flex; align-items: center; justify-content: space-between; padding-bottom: 10px; border-bottom: 1px solid rgba(255,255,255,0.12); margin-bottom: 8px; }
#batak-friends-header h3 { margin: 0; font-size: 17px; font-weight: 600; }
#batak-friends-close { width: 36px; height: 36px; border-radius: 50%; border: 1px solid rgba(255,255,255,0.2); background: transparent; color: #fff; font-size: 22px; line-height: 1; cursor: pointer; padding: 0; }
#batak-friends-list { flex: 1; overflow-y: auto; padding: 6px 2px; touch-action: pan-y; -webkit-overflow-scrolling: touch; }
.batak-friends-status { padding: 20px 8px; text-align: center; color: #8fa3c8; font-size: 14px; line-height: 1.5; }
.batak-friend-row { display: flex; align-items: center; gap: 10px; padding: 8px 6px; border-bottom: 1px solid rgba(255,255,255,0.06); }
.batak-friend-avatar { width: 44px; height: 44px; border-radius: 50%; overflow: hidden; background: #5B21B6; flex: none; display: flex; align-items: center; justify-content: center; font-weight: bold; font-size: 18px; }
.batak-friend-avatar img { width: 100%; height: 100%; object-fit: cover; }
.batak-friend-name { flex: 1; min-width: 0; font-size: 14.5px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.batak-friend-invite { flex: none; min-width: 108px; height: 38px; padding: 0 12px; border: none; border-radius: 12px; background: linear-gradient(135deg, #18c959, #0f9c42); color: #fff; font-weight: 700; font-size: 12.5px; cursor: pointer; }
.batak-friend-invite:active { transform: scale(0.95); }
.batak-friend-invite[disabled] { opacity: 0.55; }
.batak-friend-invite.pending { background: #2A2A3E; color: #9ec9ff; }
#batak-friends-toast { position: absolute; left: 14px; right: 14px; bottom: calc(env(safe-area-inset-bottom,0px) + 14px); background: rgba(20,16,40,0.96); border: 1px solid rgba(124,58,237,0.5); color: #ffb4ab; border-radius: 12px; padding: 10px 12px; font-size: 13px; text-align: center; display: none; z-index: 2; }
#batak-invite-toast { position: fixed; left: 50%; transform: translateX(-50%); bottom: calc(env(safe-area-inset-bottom,0px) + 24px); background: rgba(20,16,40,0.96); border: 1px solid rgba(24,201,89,0.5); color: #cfe3ff; border-radius: 12px; padding: 10px 16px; font-size: 13px; z-index: 9998; display: none; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
`;

const ensureDom = () => {
    if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = CSS;
        document.head.appendChild(style);
    }
    if (!document.getElementById('batak-friends')) {
        const overlay = document.createElement('div');
        overlay.id = 'batak-friends-overlay';
        const panel = document.createElement('div');
        panel.id = 'batak-friends';
        panel.innerHTML =
            '<div id="batak-friends-header"><h3>Amis</h3>' +
            '<button id="batak-friends-close">×</button></div>' +
            '<div id="batak-friends-list"></div>' +
            '<div id="batak-friends-toast"></div>';
        document.body.appendChild(overlay);
        document.body.appendChild(panel);
        overlay.onclick = closeInvitePanel;
        panel.querySelector('#batak-friends-close').onclick = closeInvitePanel;
    }
};

const state = {
    open: false,
    loading: false,
    friends: [],       // [{callerId, name, avatarUrl}]
    pending: {},       // callerId -> {invitationId, expiresAtMs}
    rowButtons: {},    // callerId -> <button>
    timer: null,
    toastTimer: null,
    opts: null,        // { socket, seatedRoomId }
};

const pickStr = (row, keys) => {
    for (const k of keys) {
        const v = row[k];
        if (v != null && v !== '') return String(v);
    }
    return '';
};

const extractPending = (inv) => {
    const map = {};
    const rows = (inv && inv.success && inv.data && inv.data.outgoing) || [];
    rows.forEach((row) => {
        if (!row) return;
        const gameType = pickStr(row, ['gameType', 'game_type']);
        if (gameType && gameType !== 'batak') return;
        const invitee = row.invitee || {};
        const callerId = pickStr(row, ['inviteeCallerId', 'invitee_caller_id', 'inviteeCallerid'])
            || pickStr(invitee, ['callerId', 'callerid', 'userId']);
        if (!callerId) return;
        const expiresAtMs = Number(pickStr(row, ['expiresAtMs', 'expires_at_ms'])) || 0;
        if (expiresAtMs && expiresAtMs <= Date.now()) return;
        map[callerId] = {
            invitationId: pickStr(row, ['invitationId', 'id', 'invitation_id']),
            expiresAtMs,
        };
    });
    return map;
};

const fmtRemain = (ms) => {
    const s = Math.max(0, Math.round(ms / 1000));
    if (s >= 3600) return Math.floor(s / 3600) + ' sa';
    if (s >= 60) return Math.floor(s / 60) + ' dk';
    return s + ' sn';
};

const panelToast = (msg) => {
    const t = document.getElementById('batak-friends-toast');
    if (!t) return;
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(state.toastTimer);
    state.toastTimer = setTimeout(() => { t.style.display = 'none'; }, 3200);
};

const paintButton = (btn, callerId) => {
    if (btn.dataset.busy === '1') return;
    const p = state.pending[callerId];
    if (p && (!p.expiresAtMs || p.expiresAtMs > Date.now())) {
        btn.className = 'batak-friend-invite pending';
        btn.textContent = '↻ Invité' + (p.expiresAtMs ? ' · ' + fmtRemain(p.expiresAtMs - Date.now()) : '');
    } else {
        if (p) delete state.pending[callerId];
        btn.className = 'batak-friend-invite';
        btn.textContent = '🎮 Inviter';
    }
    btn.disabled = false;
};

const startTimer = () => {
    if (state.timer) return;
    state.timer = setInterval(() => {
        if (!state.open) { stopTimer(); return; }
        let any = false;
        Object.keys(state.rowButtons).forEach((cid) => {
            if (state.pending[cid]) any = true;
            paintButton(state.rowButtons[cid], cid);
        });
        if (!any) stopTimer();
    }, 1000);
};

const stopTimer = () => {
    if (state.timer) { clearInterval(state.timer); state.timer = null; }
};

const sendInvite = async (f, btn) => {
    btn.dataset.busy = '1';
    btn.disabled = true;
    btn.textContent = '...';
    const seatedRoomId = (state.opts && state.opts.seatedRoomId) || null;
    const result = await sendGameInvite(f.callerId, seatedRoomId);
    btn.dataset.busy = '';
    if (!state.open) return;

    const sent = result.success && result.data && (result.data.results || [])[0];
    if (sent && sent.invitationId) {
        state.pending[f.callerId] = {
            invitationId: sent.invitationId,
            expiresAtMs: Number(sent.expiresAtMs) || 0,
        };
        startTimer();
        // Oturan davet edenin masası sunucuda bekletmeye alınır; eski sürüm
        // uygulamadaki arkadaş bu kanaldan anlık dialog alır.
        const socket = state.opts && state.opts.socket;
        if (socket) {
            socket.emit('gameInviteNotify', {
                inviteeCallerId: f.callerId,
                invitationId: sent.invitationId,
                roomId: seatedRoomId,
            });
        }
    } else {
        const err = (result.data && result.data.error) || (sent && sent.error ? { code: sent.error } : {});
        panelToast(err.message || ERROR_TR[err.code] || 'Invitation impossible');
    }
    paintButton(btn, f.callerId);
};

const render = () => {
    const list = document.getElementById('batak-friends-list');
    if (!list) return;
    list.innerHTML = '';
    state.rowButtons = {};

    state.friends.forEach((f) => {
        const row = document.createElement('div');
        row.className = 'batak-friend-row';

        const avatar = document.createElement('div');
        avatar.className = 'batak-friend-avatar';
        const initial = (f.name[0] || '?').toUpperCase();
        if (f.avatarUrl) {
            const img = document.createElement('img');
            img.src = f.avatarUrl;
            img.onerror = () => { img.remove(); avatar.textContent = initial; };
            avatar.appendChild(img);
        } else {
            avatar.textContent = initial;
        }

        const name = document.createElement('div');
        name.className = 'batak-friend-name';
        name.textContent = f.name;

        const btn = document.createElement('button');
        btn.className = 'batak-friend-invite';
        btn.onclick = () => sendInvite(f, btn);
        paintButton(btn, f.callerId);

        row.appendChild(avatar);
        row.appendChild(name);
        row.appendChild(btn);
        list.appendChild(row);
        state.rowButtons[f.callerId] = btn;
    });
};

const refresh = async () => {
    if (state.loading) return;
    const list = document.getElementById('batak-friends-list');
    if (!list) return;

    state.loading = true;
    list.innerHTML = '<div class="batak-friends-status">Chargement des amis...</div>';

    const [fr, inv] = await Promise.all([fetchFriendsList(500), fetchGameInvitations()]);
    state.loading = false;
    if (!state.open) return;

    state.friends = (fr && fr.friends) || [];
    state.pending = extractPending(inv);

    if (!fr || !fr.success) {
        list.innerHTML = fr && fr.message === 'no auth'
            ? '<div class="batak-friends-status">Tu dois ouvrir le jeu depuis l’application pour envoyer une invitation.</div>'
            : '<div class="batak-friends-status">Impossible de récupérer la liste d’amis.<br>Vérifie ta connexion puis réessaie.</div>';
        return;
    }
    if (state.friends.length === 0) {
        list.innerHTML = '<div class="batak-friends-status">Tu n’as pas encore d’amis.<br>Pendant la partie, touche le profil d’un joueur pour l’ajouter.</div>';
        return;
    }
    render();
    startTimer();
};

// ── Dışa açık API ─────────────────────────────────────────────────────────────

// opts: { socket, seatedRoomId } — seatedRoomId: masada bekliyorsa o masa, değilse null.
export const openInvitePanel = (opts = {}) => {
    ensureDom();
    state.opts = opts;
    state.open = true;
    document.getElementById('batak-friends').classList.add('visible');
    document.getElementById('batak-friends-overlay').classList.add('visible');
    refresh();
};

export const closeInvitePanel = () => {
    state.open = false;
    stopTimer();
    const panel = document.getElementById('batak-friends');
    const overlay = document.getElementById('batak-friends-overlay');
    if (panel) panel.classList.remove('visible');
    if (overlay) overlay.classList.remove('visible');
};

// Gelen oyun daveti diyaloğu (Katıl / Reddet) — her sayfadan kullanılır.
export const showGameInviteDialog = (data, opts = {}) => {
    ensureDom();
    dismissGameInviteDialog();

    const bar = document.createElement('div');
    bar.id = 'batak-game-invite';
    bar.style.cssText = 'position:fixed;top:env(safe-area-inset-top,12px);left:12px;right:12px;z-index:9999;' +
        'background:linear-gradient(135deg,#1a1a2e,#16213e);border:1px solid rgba(24,201,89,0.55);' +
        'border-radius:16px;padding:14px;box-shadow:0 6px 20px rgba(0,0,0,0.65);' +
        'font-family:sans-serif;color:#fff;display:flex;flex-direction:column;gap:10px;';

    const name = data.fromPlayerName || 'Joueur';
    const initial = (name[0] || '?').toUpperCase();
    const avatarHtml = data.fromAvatarUrl
        ? '<img src="' + data.fromAvatarUrl + '" style="width:44px;height:44px;border-radius:50%;object-fit:cover;">'
        : '<div style="width:44px;height:44px;border-radius:50%;background:#0f9c42;display:flex;align-items:center;justify-content:center;font-weight:bold;font-size:18px;">' + initial + '</div>';
    const subtitle = data.roomId ? 't’invite à sa table 🎲' : 't’invite à jouer 🎲';
    const warningHtml = opts.warning
        ? '<div style="color:#ffb74d;font-size:11.5px;">' + opts.warning + '</div>'
        : '';

    bar.innerHTML =
        '<div style="display:flex;align-items:center;gap:10px;">' +
            avatarHtml +
            '<div style="flex:1;min-width:0;">' +
                '<div style="font-weight:700;font-size:13px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + name + '</div>' +
                '<div style="color:#aaa;font-size:11.5px;">' + subtitle + '</div>' +
                warningHtml +
            '</div>' +
            '<div id="batak-ginv-close" style="cursor:pointer;padding:4px;color:#777;font-size:16px;">✕</div>' +
        '</div>' +
        '<div style="display:flex;gap:8px;">' +
            '<button id="batak-ginv-reject" style="flex:1;height:38px;border:none;border-radius:10px;background:#2A2A3E;color:#999;font-weight:600;font-size:12.5px;cursor:pointer;">Refuser</button>' +
            '<button id="batak-ginv-accept" style="flex:1;height:38px;border:none;border-radius:10px;background:linear-gradient(135deg,#18c959,#0f9c42);color:#fff;font-weight:700;font-size:12.5px;cursor:pointer;">Rejoindre</button>' +
        '</div>';

    document.body.appendChild(bar);

    bar.querySelector('#batak-ginv-close').onclick = () => bar.remove();
    bar.querySelector('#batak-ginv-accept').onclick = () => {
        bar.remove();
        if (opts.onAccept) opts.onAccept();
    };
    bar.querySelector('#batak-ginv-reject').onclick = () => {
        bar.remove();
        if (opts.onReject) opts.onReject();
    };

    setTimeout(() => {
        if (document.getElementById('batak-game-invite') === bar) bar.remove();
    }, 30000);
};

export const dismissGameInviteDialog = () => {
    const el = document.getElementById('batak-game-invite');
    if (el) el.remove();
};

// Küçük bilgi toast'ı (ör. "X daveti reddetti")
export const showInviteToast = (msg) => {
    ensureDom();
    let t = document.getElementById('batak-invite-toast');
    if (!t) {
        t = document.createElement('div');
        t.id = 'batak-invite-toast';
        document.body.appendChild(t);
    }
    t.textContent = msg;
    t.style.display = 'block';
    clearTimeout(t._timer);
    t._timer = setTimeout(() => { t.style.display = 'none'; }, 3200);
};
